'use client'
import DealCard from './DealCard'
import { AIRPORT_DB } from '@/data/airports'
import { groupByRoute } from '../hooks/useDealsShell'

export default function DealsPopularFallback({
  deals, origin, dealCounts, airports,
  onSwitchAirport, formatDealPrice, tier, lastVisit, historyMap,
}) {
  // Top airports by deal count, excluding current origin
  const topAirports = [...airports]
    .filter(ap => ap !== origin && (dealCounts[ap] ?? 0) > 0)
    .sort((a, b) => (dealCounts[b] ?? 0) - (dealCounts[a] ?? 0))
    .slice(0, 6)

  // Top 5 deals from all airports by score — grouped by route so DateChips work
  const popularDeals = groupByRoute(
    [...deals]
      .filter(d => !d._locked)
      .sort((a, b) => (b.score ?? b.discountPct / 10) - (a.score ?? a.discountPct / 10))
  ).slice(0, 5)

  if (popularDeals.length === 0) return null

  return (
    <div className="mt-6">
      <div className="mb-4 rounded-xl border border-blue-100 bg-blue-50 px-4 py-3 flex items-start gap-3">
        <span className="text-xl mt-0.5">✈️</span>
        <div>
          <p className="text-sm font-semibold text-blue-900">No deals from {origin} right now</p>
          <p className="text-xs text-blue-600 mt-0.5">Switch to a nearby airport or browse top deals below.</p>
        </div>
      </div>

      {topAirports.length > 0 && (
        <div className="mb-5 flex flex-wrap gap-2">
          {topAirports.map(ap => {
            const info = AIRPORT_DB[ap]
            const count = dealCounts[ap] ?? 0
            return (
              <button
                key={ap}
                onClick={() => onSwitchAirport(ap)}
                className="flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-3 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:border-blue-400 hover:text-blue-700 transition-colors"
              >
                {info?.flag} {info?.city ?? ap}
                <span className="ml-0.5 rounded-full bg-blue-100 px-1.5 py-0.5 text-blue-700 font-semibold">{count}</span>
              </button>
            )
          })}
        </div>
      )}

      <p className="mb-3 text-sm font-semibold text-gray-700">Other top deals right now</p>
      <ul className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {popularDeals.map(deal => (
          <li key={deal.id}>
            <DealCard
              deal={deal}
              isFlexMatch={false}
              sparklinePrices={historyMap?.[`${deal.origin}-${deal.destination}`] ?? null}
              lastVisit={lastVisit}
              tier={tier}
              showGoogleFlights={false}
              locked={false}
              priceWatchMatch={false}
              showGradient={false}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}

